import React, { useContext, useEffect, useState } from 'react'

import { BellOutlined, DragOutlined, GiftOutlined, MailOutlined, MessageOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { DndContext, PointerSensor, useSensor, useSensors, TouchSensor } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Card, Form, Table, Tag, Typography } from 'antd';

import { CreateOperationDataContext } from '../../../helpers/Context';
import showAudience from '../audience/MarketingAudienceShow';


export default function MarketingOperationCreateSelectPriority({selectedChannels}) {

  const couponChannel = selectedChannels.filter(option => option.value === "COUPON")[0]; //recupero solo i dati del canale coupon

  const [dataSource, setDataSource] = useState([]);

  const {form, handleFormChange, couponData, colorCoupons, totalUsers, selectedAudience, globalContext, selectedAudienceTitles} = useContext(CreateOperationDataContext)
  
    
  const columns = [
    {
      title: 'Canale',
      dataIndex: 'value',
      render: (value) => {
        return (
          <div className='flex gap-10 fs-15'>
            <DragOutlined/>
            {
              value === "PUSH"                 ? <BellOutlined />      :
              value === "EMAIL"                ? <MailOutlined />      :
              value === "SMS"                  ? <MessageOutlined />   :
              value === "whatsapp"             ? <WhatsAppOutlined />  : ""
            }
            {
              value === "PUSH"                 ? "Notifica Push"    :
              value === "EMAIL"                ? "E-Mail"           :
              value === "SMS"                  ? "SMS"              :
              value === "WHATSAPP"             ? "WhatsApp"         : ""
            }
          </div>
        )
      },
    },
    // {
    //   title: "Destinatari",
    //   dataIndex:"users"
    // }
  ];

  const Row = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
      id: props['data-row-key'],
    });
    const style = {
      ...props.style,
      transform: CSS.Translate.toString(transform),
      transition,
      cursor: 'move',
      ...(isDragging
        ? {
            position: 'relative',
            zIndex: 9999,
          }
        : {}),
    };
    return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
  };
    
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 150,
        tolerance: 5,
      },
    })
  );

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSource((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id);
        const overIndex = prev.findIndex((i) => i.key === over?.id);

        const newData = arrayMove(prev, activeIndex, overIndex);
        return newData;
      });
    }
  };

  useEffect(() => {
    
  const filteredChannels = selectedChannels
    .filter(option => option.value !== 'COUPON')    // Rimuove gli oggetti con `value` uguale a 'coupon'
    .map(({ children, ...rest }) => rest);          // Rimuove la proprietà `children` dagli oggetti rimanenti
  
    setDataSource(filteredChannels)
    
  },[selectedChannels])

  useEffect(() => {
    
    
    const filteredResults = dataSource
      .map(({ children, key, className, color, label, icon, users, ...rest }) => rest) //tolgo i dati inutili dall'oggetto
      .map(obj => String(obj.value)); //trasformo l'oggetto con valore in stringa nell'array
    ;   
    
    form.setFieldValue("priority", filteredResults);
    handleFormChange()
  }, [dataSource])

  // --------------- handler per evitare conflitti con lo scroll da mobile --------------- 

  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (isDragging) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none'; // blocca swipe touch su iOS
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
  }, [isDragging]);

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = ({ active, over }) => {
    setIsDragging(false);

    if (active.id !== over?.id) {
      setDataSource((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id);
        const overIndex = prev.findIndex((i) => i.key === over?.id);
        return arrayMove(prev, activeIndex, overIndex);
      });
    }
  };
  
  // --------------- handler per evitare conflitti con lo scroll da mobile --------------- 

  
  return (
   <Form.Item name={"priority"} initialValue={dataSource}>
      <div className='di-operation-wizard-wrapper'>
          
        { dataSource.length > 0 &&
          <>
            <Typography className='fs-18 bold'>Scegli l'ordine dei canali di comunicazione</Typography>
            <Typography>Per tutto ciò che contiene messaggistica (whatsapp, email, sms ece...) verrà stabilita la priorità. Se il cliente riceve il messaggio tramite il primo canale, non riceverà gli altri. Altrimenti il sistema continuerà a provare in ordine di priorità fino ad esaurirli</Typography>
            <div className='mt-20 channel-priority-table'>
            <DndContext
              sensors={sensors}
              modifiers={[restrictToVerticalAxis]}
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
            >
                <SortableContext
                  // rowKey array
                  items={dataSource.map((i) => i.key)}
                  strategy={verticalListSortingStrategy}
                >
                  <Table
                    components={{
                      body: {
                        row: Row,
                      },
                    }}
                    pagination={false}
                    rowKey="key"
                    columns={columns}
                    dataSource={dataSource}
                  />
                </SortableContext>
              </DndContext>
            </div>
          </>
        }
  
        {couponChannel &&
          <Card className='mt-20'>
            <Typography className='fs-16'>
              <Button
                type='primary'
                shape='circle'
                className='my-10'
                onClick={() =>  showAudience({
                  context:globalContext,
                  audienceIdArray: selectedAudience,
                  audienceTitlesArray: selectedAudienceTitles,
                })}
              >
                {totalUsers}
              </Button> Utenti appartenenti a: {selectedAudienceTitles.map((e)=><Tag key={e} className='fs-15 p-5'>{e}</Tag>)} riceveranno il coupon: 
              <Tag className='fs-15 bold mx-10 my-10' color={colorCoupons}>
                <GiftOutlined /> {couponData?.title}
              </Tag>
            </Typography>
          </Card>
        }
      </div>
   </Form.Item>
  )
}
